/**
 * React DOM reconciliation noise from HMR / StrictMode (removeChild / insertBefore).
 * Shared by error boundaries and Sentry filtering so matchers cannot drift.
 */
export function isRecoverableReactDomNoise(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }
  const message = error.message || '';
  return (
    error.name === 'NotFoundError' ||
    error.name === 'DOMException' ||
    message.includes('removeChild') ||
    message.includes('insertBefore') ||
    message.includes('not a child of this node') ||
    message.includes('Child to insert before is not a child')
  );
}
